<template>
  <div ref="preview"></div>
</template>

<script setup>
import { useTemplateRef, onMounted } from "vue";

const props = defineProps({
  file: {
    type: File,
    required: true,
  }
});

const previewRef = useTemplateRef('preview');
const readAndPreview = (file) => {
  previewRef.value.innerHTML = '';

  if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
    var reader = new FileReader();

    reader.addEventListener("load", function () {
      var image = new Image();
      image.title = file.name;
      image.src = this.result;
      image.style = "object-fit: cover; height: 80px !important; width: 80px !important;";
      previewRef.value.appendChild(image);
    }, false);

    reader.readAsDataURL(file);
  }
}

onMounted(() => {
  readAndPreview(props.file);
})
</script>

<style scoped>

</style>